import * as React from "react";
import { useQueryClient } from "react-query";
import Service from "../common/Services/Service";

import { useStoreState } from "../store";

import useReload from "./useReload";
import useServiceSetup from "./useServiceSetup";

function useAuthManager() {
  const authorized = useStoreState((state) => state.auth.authorized);

  const tokens = useStoreState((state) => state.auth.tokens);
  const role = useStoreState((state) => state.preferences.role);

  const queryClient = useQueryClient();
  const reload = useReload("useAuthManager");

  const { isSetup, setup, teardown } = useServiceSetup();

  const roleCache = React.useRef(role);
  const isRoleChanged = role !== roleCache.current;
  const isReady = !tokens || (!!tokens && isSetup);

  React.useEffect(() => {
    if (!isSetup && role && tokens) {
      setup({ role, tokens });
    }
  }, [isSetup, tokens, role]);

  React.useEffect(() => {
    if (tokens && isRoleChanged) {
      setup({ role, tokens }).then(() => {
        queryClient.clear();
        reload();
      });
    }

    roleCache.current = role;
  }, [isRoleChanged, role, tokens, reload, queryClient]);

  React.useEffect(() => {
    if (!authorized && Service.isSetup()) {
      teardown().then(() => {
        queryClient.clear();
        reload();
      });
    }
  }, [authorized, teardown, queryClient, reload]);

  return {
    isReady,
  };
}

export default useAuthManager;
